import {useQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    CompanyApproverDto,
    CompanyApproverPaginator,
    CreateCompanyApproverDto,
    UpdateCompanyApproverDto,
    QueryCompanyApproverDto,
} from "../models/company-approver.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetCompanyApprover(companyId: number, query?: QueryCompanyApproverDto) {
    const url = ENDPOINTS.HR.COMPANY_APPROVER.GET;
    const request = API.HrAPI.getCompanyApprover(companyId, query);

    const { data, isLoading, error } = useQuery<CompanyApproverPaginator, Error>(
        [url, companyId],
        (() => request),
        { enabled: !!(companyId) },
    );
    
    return { data, isLoading, error };
}

export function useGetCompanyApproverById(companyId: number, id: number) {
    const url = ENDPOINTS.HR.COMPANY_APPROVER.DETAIL
    const request = API.HrAPI.getCompanyApproverById(companyId, id);

    const {data, isLoading, error} = useQuery<{ data:CompanyApproverDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateCompanyApprover() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ companyId, payload }: { companyId: number, payload: CreateCompanyApproverDto }) => API.HrAPI.createCompanyApprover(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.HR.COMPANY_APPROVER.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateCompanyApprover() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ payload, id, companyId }: { payload: UpdateCompanyApproverDto, id: number, companyId: number }) => API.HrAPI.updateCompanyApprover(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.HR.COMPANY_APPROVER.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteGradeLevel() {

    return useMutation(
        ({ companyId, id }: { companyId: number, id: number }) => API.HrAPI.deleteCompanyApprover(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}